import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { modelMenu } from '../../model/menu';

@Component({
  selector: 'app-menu2',
  templateUrl: './menu2.component.html',
  styleUrls: ['./menu2.component.css']
})
export class Menu2Component implements OnInit {
  modMenu2:modelMenu[]=[];

  constructor(private router:Router, public dialogRef: MatDialogRef<Menu2Component>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.modMenu2 = [];
    var auxMenu;
    if(this.data){
      for (var i = 0; i < this.data.modMenu2.length; i++){
        if(this.data.modMenu2[i].tip == this.data.nivel1){
            this.modMenu2.push (this.data.modMenu2[i]);
        }
      }
    }
    setTimeout(() => {
      for(var i=0; i < this.modMenu2.length; i++){
        auxMenu = document.getElementById("divItemImagen_"+this.modMenu2[i].a);
        if(this.modMenu2[i].i)
          auxMenu.style.backgroundImage = "url('/assets/imgs/hup/" + this.modMenu2[i].i + "')";
  }      
    }, 15);
  }

  fnClickMenuItem(i){
    console.log(i);
    if(i.a.substr(0,1)==">"){
      //console.log("MOSTRAR 3er NIVEL: " + i.a);
    }
    else{
      this.dialogRef.close();
      this.router.navigate([i.a]);
    }
  }

}
